module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('van-cell-group', _vm._l((_vm.row.subject_list), function(subject, index) {
    return _c('van-cell', {
      key: index,
      attrs: {
        "title": '项目' + (index + 1)
      },
      on: {
        "click": function($event) {
          return _vm.downloadCert(subject)
        }
      },
      scopedSlots: _vm._u([{
        key: "right-icon",
        fn: function() {
          return [(subject.have_cert) ? _c('div', {
            staticClass: "tiny-btn-1"
          }, [_vm._v("下载证书")]) : _vm._e()]
        },
        proxy: true
      }, {
        key: "label",
        fn: function() {
          return [_c('div', [_vm._v(_vm._s(subject.subject_name))]), _vm._v(" "), _c('div', [_vm._v("\n                    运动员:\n                    "), _vm._l((subject.yundongyuan), function(member, index) {
            return _c('span', {
              key: index,
              staticStyle: {
                "color": "#111"
              }
            }, [_vm._v(_vm._s(member.name) + " ")])
          })], 2)]
        },
        proxy: true
      }], null, true)
    })
  }), 1), _vm._v(" "), _c('van-popup', {
    staticStyle: {
      "width": "80%",
      "height": "auto",
      "text-align": "center"
    },
    model: {
      value: (_vm.showCert),
      callback: function($$v) {
        _vm.showCert = $$v
      },
      expression: "showCert"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "height": "auto"
    },
    attrs: {
      "src": _vm.certUrl
    }
  }), _vm._v(" "), (!_vm.isApp) ? _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    }
  }, [_vm._v("请长按图片保存")]) : _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    },
    on: {
      "click": _vm.appDownload
    }
  }, [_vm._v("点击下载证书")])], 1), _vm._v(" "), _c('van-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('van-loading', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "200px"
    },
    attrs: {
      "type": "spinner"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65fddca9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiCertList.vue
// module id = 1460
// module chunks = 0